import { ConsoleLogger } from "aws-amplify/utils";

// eslint-disable-next-line
export const amplifyLogger = new ConsoleLogger("LLTS-Logger", "VERBOSE");
